<div class="header">
	<ion-img class="logo" src="../../../assets/dean_and_david/logo.png" alt=""></ion-img>
	<ng-container *ngIf="venue">
		<div class="venue_info_block" role="region" aria-label="Venue information block">
			<ion-icon
				(click)="back.emit()"
				src="../../../assets/dean_and_david/edit_venue.svg"
				role="img"
				aria-label="Edit venue"
			></ion-icon>
			<div>
				<h3>{{ venue.street }} {{ venue.city.de }}</h3>
				<p>
					{{ 'preorder_type.' + order?.preorder?.type | translate }} ·
					{{ todayDate.toString() | date: 'dd. MMMM  yyyy' }}
				</p>
			</div>
		</div>
	</ng-container>
	<div class="block_info" role="region" aria-label="Information block">
		<ion-button
			(click)="showBasket.emit()"
			class="show-basket"
			*ngIf="order && showGoToBasketBtn && order?.orderedArticles?.length > 0"
		>
			<ion-icon src="../../../assets/dean_and_david/white-basket.svg" role="img" aria-label="Basket icon"></ion-icon>
			<h4>{{ formattedPrice }}</h4>
		</ion-button>
		<div
			class="flag-item"
			(click)="openPopoverSelectionLanguage($event)"
			(keydown.enter)="openPopoverSelectionLanguage($event)"
			(keydown.space)="openPopoverSelectionLanguage($event)"
			role="button"
			tabindex="0"
		>
			<ion-img [src]="findFlag()" alt=""></ion-img>
		</div>

		<ion-button *ngIf="customer?.isAnonymous && !showGoToBasketBtn" (click)="navToLogin()" class="login-btn">
			<ion-icon src="../../../assets/dean_and_david/user_icon.svg" role="img" aria-label="User icon"></ion-icon>
			<h4>{{ 'menu_popover.login' | translate }}</h4>
		</ion-button>
		<div *ngIf="!customer?.isAnonymous" class="user-login" (click)="myPorfile()" role="button" tabindex="0">
			<ion-icon src="../../../assets/dean_and_david/my_profile.svg" role="img" aria-label="My Profile"></ion-icon>
		</div>

		<app-burger-btn></app-burger-btn>
	</div>
</div>
